import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/if"

export function ChangeLegislationListItem({ item: leg }) {
    return (
        <ListItemButton disableGutters dense onClick={openLink} sx={{ py: 0.25 }}>
            <ListItemIcon sx={{ minWidth: 28 }}>
                <Iconify icon="mdi:file-document-outline" sx={{ fontSize: 16, color: "text.secondary" }} />
            </ListItemIcon>
            <ListItemText
                primary={leg.title || leg.ref}
                primaryTypographyProps={{ variant: "caption", color: "text.secondary" }}
            />
            <If truthy={leg.url}>
                <Tooltip title="Open legislation in new tab">
                    <ListItemIcon sx={{ minWidth: "auto", ml: 0.5 }}>
                        <Iconify icon="mdi:open-in-new" sx={{ fontSize: 14, color: "text.secondary" }} />
                    </ListItemIcon>
                </Tooltip>
            </If>
        </ListItemButton>
    )

    function openLink() {
        if (leg.url) window.open(leg.url, "_blank", "noopener,noreferrer")
    }
}
